import { API_ROUTES } from "../config";
import { http } from "../http";

export const createTaskTypeService = async (data) => {
    try {
        const responseData = await http().post(API_ROUTES["kpi-task-types"], data);
        return responseData;
    } catch (err) {
        console.log('err', err);
        throw err;
    }
};

export const getTaskTypesService = async () => {
    try {
        const responseData = await http().get(API_ROUTES["kpi-task-types"]);
        return responseData;
    } catch (err) {
        console.log('err', err);
        throw err;
    }
};

export const updateTaskTypeService = async (id, data) => {
    try {
        const responseData = await http().put(`${API_ROUTES["kpi-task-types"]}/${id}`, data);
        return responseData;
    } catch (err) {
        console.log('err', err);
        throw err;
    }
};

export const getDashboardService = async () => {
    try {
        const responseData = await http().get(API_ROUTES["kpi-dashboard"]);
        return responseData;
    } catch (err) {
        console.log('err', err);
        throw err;
    }
};

export const getTransactionsService = async (params = {}) => {
    try {
        const responseData = await http().get(API_ROUTES["kpi-transactions"], { params });
        return responseData;
    } catch (err) {
        console.log('err', err);
        throw err;
    }
};

export const getLeaderboardService = async () => {
    try {
        const responseData = await http().get(API_ROUTES["kpi-leaderboard"]);
        return responseData;
    } catch (err) {
        console.log('err', err);
        throw err;
    }
};

export const getTrendService = async (params = {}) => {
    try {
        const responseData = await http().get(API_ROUTES["kpi-trend"], { params });
        return responseData;
    } catch (err) {
        console.log('err', err);
        throw err;
    }
};

export const getMyWorksService = async (params = {}) => {
    try {
        const responseData = await http().get(API_ROUTES["kpi-my-works"], { params });
        return responseData;
    } catch (err) {
        console.log('err', err);
        throw err;
    }
};

export const getCategoryBreakdownService = async (params = {}) => {
    try {
        const responseData = await http().get(API_ROUTES["kpi-category-breakdown"], { params });
        return responseData;
    } catch (err) {
        console.log('err', err);
        throw err;
    }
};

export const getTeamReviewService = async (params = {}) => {
    try {
        const responseData = await http().get(API_ROUTES["kpi-team-review"], { params });
        return responseData;
    } catch (err) {
        console.log('err', err);
        throw err;
    }
};

export const getHeatmapService = async (params = {}) => {
    try {
        const responseData = await http().get(API_ROUTES["kpi-heatmap"], { params });
        return responseData;
    } catch (err) {
        console.log('err', err);
        throw err;
    }
};

export const getEligibleUsersService = async (params = {}) => {
    try {
        const responseData = await http().get(API_ROUTES["kpi-eligible-users"], { params });
        return responseData;
    } catch (err) {
        console.log('err', err);
        throw err;
    }
};

export const getMyWorkDetailService = async (id) => {
    try {
        const responseData = await http().get(`${API_ROUTES["kpi-my-works"]}/${id}`);
        return responseData;
    } catch (err) {
        console.log('err', err);
        throw err;
    }
};

export const editRecurrenceService = async (id, data) => {
    try {
        const responseData = await http().put(`${API_ROUTES["edit-recurrence"]}/${id}`, data);
        return responseData;
    } catch (err) {
        console.log('err', err);
        throw err;
    }
};

export const softDeleteWorkService = async (taskId) => {
    try {
        const responseData = await http().put(`/project/task/soft-del-tasks?task_id=${taskId}`);
        return responseData;
    } catch (err) {
        console.log('err', err);
        throw err;
    }
};

export const hardDeleteWorkService = async (taskId) => {
    try {
        const responseData = await http().delete(`/project/task/delete-tasks?task_id=${taskId}`);
        return responseData;
    } catch (err) {
        console.log('err', err);
        throw err;
    }
};

export const getKPIProjectsHierarchyService = async (params = {}) => {
    try {
        const responseData = await http().get(API_ROUTES["kpi-projects"], { params });
        return responseData;
    } catch (err) {
        console.log('err', err);
        throw err;
    }
};

export const createProjectGroupService = async (data) => {
    try {
        const responseData = await http().post(API_ROUTES["add-group"], data);
        return responseData;
    } catch (err) {
        console.log('err', err);
        throw err;
    }
};

export const getUpcomingRecurringService = async (params = {}) => {
    try {
        const responseData = await http().get(API_ROUTES["kpi-recurring-upcoming"], { params });
        return responseData;
    } catch (err) {
        console.log('err', err);
        throw err;
    }
};

export const getAdminDashboardService = async (params = {}) => {
    try {
        const responseData = await http().get(API_ROUTES["kpi-admin-dashboard"], { params });
        return responseData;
    } catch (err) {
        console.log('err', err);
        throw err;
    }
};

export const getActivityLogService = async (params = {}) => {
    try {
        const responseData = await http().get(API_ROUTES["kpi-activity-log"], { params });
        return responseData;
    } catch (err) {
        console.log('err', err);
        throw err;
    }
};

export const getMonthlyTargetsService = async (params = {}) => {
    try {
        const responseData = await http().get(API_ROUTES["kpi-monthly-target"], { params });
        return responseData;
    } catch (err) {
        console.log('err', err);
        throw err;
    }
};

export const createMonthlyTargetService = async (payload) => {
    try {
        const responseData = await http().post(API_ROUTES["kpi-monthly-target"], payload);
        return responseData;
    } catch (err) {
        console.log('err', err);
        throw err;
    }
};

export const updateMonthlyTargetService = async (id, payload) => {
    try {
        const responseData = await http().put(`${API_ROUTES["kpi-monthly-target"]}/${id}`, payload);
        return responseData;
    } catch (err) {
        console.log('err', err);
        throw err;
    }
};

export const deleteMonthlyTargetService = async (id) => {
    try {
        const responseData = await http().delete(`${API_ROUTES["kpi-monthly-target"]}/${id}`);
        return responseData;
    } catch (err) {
        console.log('err', err);
        throw err;
    }
};

export const getRecurringDetailService = async (id) => {
    try {
        const responseData = await http().get(`${API_ROUTES["kpi-recurring"]}/${id}`);
        return responseData;
    } catch (err) {
        console.log('err', err);
        throw err;
    }
};

export const updateRecurringStatusService = async (id, statusPayload) => {
    try {
        const responseData = await http().patch(`${API_ROUTES["kpi-recurring"]}/${id}/status`, statusPayload);
        return responseData;
    } catch (err) {
        console.log('err', err);
        throw err;
    }
};

export const editRecurringScheduleService = async (id, payload) => {
    try {
        const responseData = await http().put(`${API_ROUTES["kpi-recurring"]}/${id}`, payload);
        return responseData;
    } catch (err) {
        console.log('err', err);
        throw err;
    }
};



